import { Button } from '@apps/web/components/ui/button';

const CONFIRM_CLEAR_THRESHOLD = 5;

export function BulkAskAvailabilityBar({
    selectedCount,
    batchCount,
    nextBatchNumber,
    allBatchesAsked,
    onAsk,
    onClear,
}: {
    readonly selectedCount: number;
    readonly batchCount: number;
    readonly nextBatchNumber: number;
    readonly allBatchesAsked: boolean;
    readonly onAsk: () => void;
    readonly onClear: () => void;
}) {
    if (selectedCount === 0) {
        return null;
    }

    const askLabel = allBatchesAsked
        ? 'Availability requested'
        : batchCount > 1
          ? `Request availability (batch ${nextBatchNumber} of ${batchCount})`
          : 'Request availability';
    const isReplacingPriorBatch = !allBatchesAsked && nextBatchNumber > 1;

    return (
        <div className="bg-muted/50 border-border flex flex-wrap items-center gap-x-3 gap-y-1 rounded-lg border px-3 py-2">
            <span
                className="text-sm font-medium tabular-nums"
                aria-live="polite"
            >
                {selectedCount} selected
            </span>
            <div className="grow" />
            <Button
                variant="ghost"
                size="sm"
                onClick={() => {
                    if (
                        selectedCount > CONFIRM_CLEAR_THRESHOLD &&
                        !window.confirm(
                            `Clear ${selectedCount} selected caregivers? You’ll need to select them again.`,
                        )
                    ) {
                        return;
                    }
                    onClear();
                }}
            >
                Clear
            </Button>
            <Button
                size="sm"
                disabled={allBatchesAsked}
                onClick={onAsk}
                title="Opens the chat panel with a draft message to these caregivers. It won’t send until you do."
            >
                {askLabel}
            </Button>
            {isReplacingPriorBatch ? (
                <span className="text-muted-foreground basis-full text-xs">
                    Asking this batch replaces the current draft in chat.
                </span>
            ) : null}
        </div>
    );
}
